import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.is-array";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var TaxonomyMapper =
/*#__PURE__*/
function () {
  function TaxonomyMapper() {
    _classCallCheck(this, TaxonomyMapper);
  }

  _createClass(TaxonomyMapper, [{
    key: "mapTaxonomy",
    value: function mapTaxonomy(taxonomySystem, taxonomyTerms) {
      if (!taxonomySystem) {
        throw Error("Cannot map taxonomy due to missing 'system' property");
      }

      if (!taxonomyTerms) {
        throw Error("Cannot map taxonomy due to missing 'terms' property");
      }

      if (!Array.isArray(taxonomyTerms)) {
        throw Error("Cannot map terms because no terms array was provided");
      }

      var mappedSystemAttributes = {
        name: taxonomySystem.name,
        codename: taxonomySystem.codename,
        id: taxonomySystem.id,
        lastModified: taxonomySystem.last_modified
      };
      var mappedTerms = this.mapTaxonomyTerms(taxonomyTerms);
      return {
        system: mappedSystemAttributes,
        terms: mappedTerms
      };
    }
  }, {
    key: "mapTaxonomies",
    value: function mapTaxonomies(taxonomies) {
      var _this = this;

      if (!taxonomies) {
        throw Error("Cannot map taxonomy due to missing 'taxonomies' property");
      }

      if (!Array.isArray(taxonomies)) {
        throw Error("Cannot map taxonomies because the 'taxonomies' property is not an array ");
      }

      var mappedTaxonomies = [];
      taxonomies.forEach(function (taxonomy) {
        mappedTaxonomies.push(_this.mapTaxonomy(taxonomy.system, taxonomy.terms));
      });
      return mappedTaxonomies;
    }
    /**
     * Recursively map array of taxonomy terms
     * @param termsArray Terms array to map
     */

  }, {
    key: "mapTaxonomyTerms",
    value: function mapTaxonomyTerms(termsArray) {
      var _this2 = this;

      if (termsArray.length === 0) {
        return [];
      }

      var mappedTermsArray = [];
      termsArray.forEach(function (terms) {
        var mappedTerms = {
          codename: terms.codename,
          name: terms.name,
          terms: _this2.mapTaxonomyTerms(terms.terms)
        };
        mappedTermsArray.push(mappedTerms);
      });
      return mappedTermsArray;
    }
  }]);

  return TaxonomyMapper;
}();